import { render, staticRenderFns } from "./UploadSingleImg.vue?vue&type=template&id=57939891&scoped=true"
import script from "./UploadSingleImg.vue?vue&type=script&lang=js"
export * from "./UploadSingleImg.vue?vue&type=script&lang=js"
import style0 from "./UploadSingleImg.vue?vue&type=style&index=0&id=57939891&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57939891",
  null
  
)

export default component.exports